// @flow

import React, { type Node } from 'react';

import { type LookAndFeelRootPropsOpenedPayment } from '@tectonics/look-and-feel';

export function NullPagePaymentOpened({
  selectedPaymentMethod,
  appValues,
  userInputValues,
  userInputValidationErrors,
  submitError,
}: LookAndFeelRootPropsOpenedPayment): Node {
  return (
    <>
      <p>
        <strong>Selected Payment Method:</strong>{' '}
        <code>{selectedPaymentMethod ? selectedPaymentMethod.code : '[none]'}</code>
      </p>
      <p>
        <strong>User Input Values:</strong>
      </p>
      <pre>
        {JSON.stringify(userInputValues, null, 2)}
      </pre>
      <pre>
        {JSON.stringify(userInputValidationErrors, null, 2)}
      </pre>
      <pre>
        {JSON.stringify(submitError, null, 2)}
      </pre>
      <p>
        <strong>AppValues</strong>
      </p>
      <pre>
        {JSON.stringify(appValues, null, 2)}
      </pre>
    </>
  );
}
